export default [
  {
    path: '',
    name: 'supplier list',
    component: () => import('@/views/app/supplier/list/page-list.vue'),
    meta: { title: 'Daftar Supplier' },
  },
]
